import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { FaEye, FaEyeSlash, FaHelmetSafety, FaBuilding, FaBoxesStacked, FaClipboardCheck } from 'react-icons/fa6';

const FEATURES = [
  { icon: FaBoxesStacked, bn: 'প্রতিটি কন্ট্রাক্টরের জন্য আলাদা মাল স্টক', en: 'Separate stock per contractor' },
  { icon: FaClipboardCheck, bn: 'হাজিরা + ছবি, দিনে এক ক্লিকে', en: 'Attendance with photos, one tap a day' },
  { icon: FaBuilding, bn: 'প্রজেক্ট, মজুরি ও খরচ সব এক জায়গায়', en: 'Projects, wages & expenses in one place' },
];

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await login(phone, password);
      nav('/');
    } catch (e) {
      setErr(e.response?.data?.message || 'লগইন ব্যর্থ হয়েছে');
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-dvh flex bg-slate-50">
      {/* Brand panel — desktop */}
      <div className="hidden lg:flex w-1/2 bg-ink-900 text-white flex-col justify-between p-12 relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-brand-500/10" />
        <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full bg-brand-500/5" />
        <div className="relative">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-brand-400 to-brand-600 text-white flex items-center justify-center text-xl"><FaHelmetSafety /></div>
            <div>
              <div className="font-bold text-lg">Construction MS</div>
              <div className="text-xs text-ink-400">নির্মাণ ব্যবস্থাপনা</div>
            </div>
          </div>
          <h2 className="mt-10 text-3xl font-bold leading-snug max-w-md">
            ১০–২০ থেকেলার ভবন, <span className="text-brand-400">একটি অ্যাপে</span> সম্পূর্ণ ব্যবস্থাপনা
          </h2>
          <div className="mt-8 space-y-4">
            {FEATURES.map((f) => (
              <div key={f.bn} className="flex items-center gap-3 text-sm text-ink-200">
                <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-brand-400"><f.icon /></span>
                {f.bn}
              </div>
            ))}
          </div>
        </div>
        <div className="relative text-xs text-ink-400">© 2026 Construction MS — Cloudflare Pages + D1</div>
      </div>

      {/* Form panel */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2.5 justify-center mb-8">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-brand-400 to-brand-600 text-white flex items-center justify-center text-lg"><FaHelmetSafety /></div>
            <div className="font-bold text-ink-900 text-lg">Construction MS</div>
          </div>

          <div className="bg-white rounded-2xl border border-ink-100 shadow-card p-6 sm:p-7">
            <h1 className="text-lg font-bold text-ink-900">লগইন করুন</h1>
            <p className="text-sm text-ink-400 mt-0.5">অ্যাকাউন্টে প্রবেশ করতে ফোন ও পাসওয়ার্ড দিন</p>
            {err && <div className="mt-4 text-sm bg-rose-50 text-rose-600 px-3 py-2.5 rounded-xl flex items-center gap-2"><span>⚠️</span>{err}</div>}
            <form onSubmit={submit} className="space-y-4 mt-5">
              <div>
                <label className="label">ফোন নম্বর</label>
                <input className="input" placeholder="01XXXXXXXXX" value={phone} onChange={(e) => setPhone(e.target.value)} inputMode="tel" required />
              </div>
              <div>
                <label className="label">পাসওয়ার্ড</label>
                <div className="relative">
                  <input className="input pr-11" type={show ? 'text' : 'password'} placeholder="••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />
                  <button type="button" onClick={() => setShow(s => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-400 hover:text-ink-600"><span className="text-lg">{show ? <FaEyeSlash /> : <FaEye />}</span></button>
                </div>
              </div>
              <button disabled={busy} className="btn-primary w-full py-3 text-sm font-semibold">
                {busy ? 'লগইন হচ্ছে…' : 'লগইন করুন'}
              </button>
            </form>
          </div>

          <p className="text-center text-sm text-ink-500 mt-5">
            নতুন প্রজেক্ট? <Link to="/register" className="font-semibold text-brand-600 hover:text-brand-700">অ্যাকাউন্ট খুলুন</Link>
          </p>
        </div>
      </div>
    </div>
  );
}